<template>
    <div class="director-box">
        <div class="director-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="director-box-common director-box-infor">
                <h3>专业介绍</h3>
                <p>编导专业属于广播影视传媒艺术，是近年来的一个异军突起的艺术专业，它是兴起在美术、音乐专业之外的又一大类高等艺术教育专业。随着中国文化产业的迅猛发展，国家需要大量的广播影视传媒人才。<br> 编导就是编和导，从编导从事的工作性质来看编可理解为：编写、编撰、编排、编辑、编剧等；导可理解为：引导、指导、领导、导向、导播、导演等。所以，从字面理解编导就是即能编又能导的复合型人才和职业。编导，是广播电视行业一个专有名词。</p>
            </div>
        </div> 
        <div class="director-box-work director-box-common director-box-common1">
            <h3>就业方向</h3>
            <h4>
                学编导可以丰富人生阅历，提高综合素质，属于复合型人才，就业前景非常广阔
            </h4>
            <el-row type="flex" justify="space-between" class="director-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="director-box-tiao director-box-common">
            <h3>报考条件</h3>
            <el-row class="director-box-tiao-content">
                <el-col :span="6" v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="director-box-test director-box-common director-box-common1">
            <h3>考试内容</h3>
            <h4>编导类专业考试分类一般分为笔试和面试</h4>
            <el-row class="director-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="director-box-subject director-box-common director-box-common1">
            <h3>学习科目</h3>
            <h4>电视节目分析，录音艺术会有视唱练耳声乐，文艺编导会有才艺展示等</h4>
            <el-row class="director-box-subject-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="director-box-tips director-box-common director-box-common1">
            <h3>考试流程</h3>
            <el-row class="director-box-tips-content" type="flex" justify="space-between">
                <el-col class="director-box-tips-item1">
                    <h4>一、面试</h4>
                    <div>
                        <span class="director-box-tips-count">科目一</span>
                        <span>命题演讲、命题讲故事</span>
                    </div>
                    <div>
                        <span class="director-box-tips-count">科目二</span>
                        <span>回答考官提问</span>
                    </div>
                    <div>
                        <span class="director-box-tips-count">科目三</span>
                        <span>自我介绍</span>
                    </div>
                    <div>
                        <span class="director-box-tips-count">科目四</span>
                        <span>特长展示（声乐、器乐、 舞蹈、曲艺等）</span>
                    </div>
                </el-col>
                <el-col class="director-box-tips-item2">
                    <h4>二、笔试</h4>
                    <div>1、综合知识及命题写作；</div>
                    <div>2、影视作品分析，试卷有文艺常识 填空。</div>
                </el-col>
                <el-col class="director-box-tips-item3">
                    <h4>三、笔试</h4>
                    <div>根据影片写影评或根据题目写广告策划</div>
                </el-col>
            </el-row>
        </div>
        <div class="director-box-school director-box-common director-box-common1">
            <h3>推荐院校</h3>
            <el-row class="director-box-school-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <img :src="item.src" alt="">
                    <span>{{item.desc}}</span>
                </el-col>
            </el-row>
        </div>
        <div class="director-box-order" id="add">
            <div class="director-box-order-content director-box-common director-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/director-work-icon1.png'),desc:'文化经纪人'},
                {src:require('../../assets/images/director-work-icon2.png'),desc:'影视制片人'},
                {src:require('../../assets/images/director-work-icon3.png'),desc:'文艺编导'},
                {src:require('../../assets/images/director-work-icon4.png'),desc:'音响导演'},
                {src:require('../../assets/images/director-work-icon5.png'),desc:'影视编剧'},
                {src:require('../../assets/images/director-work-icon6.png'),desc:'节目策划'},
                {src:require('../../assets/images/director-work-icon7.png'),desc:'影视导演'},
                {src:require('../../assets/images/director-work-icon8.png'),desc:'自由撰稿人'},
            ],
            tiaoList:[
                {src:require('../../assets/images/director-tiao-icon1.png'),desc:'热爱生活，身心健康，无不良嗜好'},
                {src:require('../../assets/images/director-tiao-icon2.png'),desc:'热爱生活、热爱艺术'},
                {src:require('../../assets/images/director-tiao-icon3.png'),desc:'满16周岁，在校艺术类高中生及职高学生'},
                {src:require('../../assets/images/director-tiao-icon4.png'),desc:'文化课功底好，成绩300分以上'},
            ],
            testList:[
                {src:require('../../assets/images/director-test-icon1.png'),desc:'命题演讲'},
                {src:require('../../assets/images/director-test-icon2.png'),desc:'命题讲故事'},
                {src:require('../../assets/images/director-test-icon3.png'),desc:'自我介绍'},
                {src:require('../../assets/images/director-test-icon8.png'),desc:'广告策划'},
                {src:require('../../assets/images/director-test-icon4.png'),desc:'影视作品分析'},
                {src:require('../../assets/images/director-test-icon6.png'),desc:'文艺常识填空'},
                {src:require('../../assets/images/director-test-icon5.png'),desc:'特长展示'},
                {src:require('../../assets/images/director-test-icon7.png'),desc:'综合知识及命题写作'},
            ],
            subjectList:[
                {src:require('../../assets/images/director-subject-icon1.png'),desc:'面试技巧'},
                {src:require('../../assets/images/director-subject-icon2.png'),desc:'即兴评述'},
                {src:require('../../assets/images/director-subject-icon3.png'),desc:'影评分析'},
                {src:require('../../assets/images/director-subject-icon4.png'),desc:'叙事散文'},
                {src:require('../../assets/images/director-subject-icon5.png'),desc:'编写故事'},
                {src:require('../../assets/images/director-subject-icon6.png'),desc:'电视节目分析'},
                {src:require('../../assets/images/director-subject-icon7.png'),desc:'校考试题'},
                {src:require('../../assets/images/director-subject-icon8.png'),desc:'影评鉴赏'},
                {src:require('../../assets/images/director-subject-icon9.png'),desc:'文艺常识'},
                {src:require('../../assets/images/director-subject-icon10.png'),desc:'命题写作'},
            ],
            schoolList:[
                {src:require('../../assets/images/director-school-icon1.jpg'),desc:'中国传媒大学'},
                {src:require('../../assets/images/director-school-icon2.jpg'),desc:'浙江传媒学院'},
                {src:require('../../assets/images/director-school-icon3.jpg'),desc:'北京电影学院'},
                {src:require('../../assets/images/director-school-icon4.jpg'),desc:'中国戏剧学院'},
                {src:require('../../assets/images/director-school-icon5.jpg'),desc:'上海戏剧学院'},
                {src:require('../../assets/images/director-school-icon6.jpg'),desc:'湖南大学'},
                {src:require('../../assets/images/director-school-icon7.jpg'),desc:'吉林大学'},
                {src:require('../../assets/images/director-school-icon8.jpg'),desc:'四川大学'},
            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '1'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.director-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.director-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 24px;
        margin: 24px 0 62px 0;
    }
}
.director-box-bg {
    background: url('../../assets/images/director-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(255,255,255,0.20)!important;
        border: 1px solid #ffffff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(255,255,255,0)!important;
    }
}
.director-box-infor {
    width: $width;
    margin: $margin;
    height: 361px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.director-box-work {
    padding-top: 235px;
    height: 652px;
    background: #f5f7fa;
    box-sizing: border-box;
    .director-box-work-list {
        width: $width;
        margin: $margin;
    }
    .el-col {
        width: 130px;
        text-align: center;
        h5 {
            margin-top: 20px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
        }
    }
}
.director-box-tiao {
    height: 568px;
    background: linear-gradient(180deg,#3f3a37, #211d1b 99%);
    position: relative;
    h3 {
        color: #ffffff;
    }
    .director-box-tiao-content {
        width: $width;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        h5 {
            position: absolute;
            top: 452px;
            padding: 0 30px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            color: #ffffff;
            line-height: 38px;
            margin: 0;
            width: 300px;
            box-sizing: border-box;
            text-align: center;
        }
    }
}
.director-box-test {
    background: url('../../assets/images/director-test-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 722px;
    .director-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            width: 265px;
            h5 {
                background: url('../../assets/images/director-test-img.png') no-repeat;
                width: 265px;
                height: 44px;
                line-height: 44px;
                background-size: 100% 100%;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                margin: 15px 0 47px 0;
            }
        }
    }
}
.director-box-subject {
    width: 100%;
    height: 627px;
    background: #ff8638;
    h3 {
        color: #fff;
    }
    h4 {
        color: rgba(255,255,255,0.60);
    }
    .director-box-subject-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            width: 20%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 20px 0 60px 0;
            }
        }
    }
}
.director-box-tips {
    width: 100%;
    height: 558px;
    background: #ffff;
    .director-box-tips-content {
        width: $width;
        margin: $margin;
        margin-top: 48px;
        .el-col {
            width: 380px;
            height: 340px;
            border-radius: 8px;
            padding: 30px 32px;
            box-sizing: border-box; 
            h4 {
                font-size: 28px;
                font-family: $font-family;
                font-weight: 700;
                color: #2c3331;
                margin: 0;
                margin-bottom: 2px;
                line-height: 37px;
            }
            div {
                margin-top: 26px;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
            }
            span {
                display: inline-block;
                width: 71%;
                margin-left: 82px;
            }
            .director-box-tips-count {
                width: 74px;
                height: 30px;
                background: #348aff;
                border-radius: 5px;
                font-size: 16px;
                font-family: $font-family;
                font-weight: 400;
                color: #ffffff;
                line-height: 30px;
                text-align: center;
                margin-right: 10px;
                position: absolute;
                top: 0;
                margin-left: 0;
                
            }
        }
        .director-box-tips-item1 {
            background: #ecf4ff;
            border: 1px solid #b3d3ff;
        }
        .director-box-tips-item2 {
            background: #fff4eb;
            border: 1px solid #ffdbbd;
        }
        .director-box-tips-item3 {
            background: #f2f7e7;
            border: 1px solid #c4de89;
        }
    }
}
.director-box-school {
    height: 443px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .director-box-school-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col {
            padding:16px;
            width: 265px;
            height: 88px;
            background: #ffffff;
            border-radius: 8px;
            margin-top: 48px;
            span {
                display: inline-block;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                top: -18px;
                left: 12px;
            }
        }
    }
}
.director-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background-color: #ff8638;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        color: rgba(255,255,255,0.60);
        margin-bottom: 55px;
        
    }
    .director-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .director-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .director-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>